import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ReceptorService } from 'src/app/services/receptor.service';
import { UsuariosService } from '../services/usuarios.service';
import { AuthService } from '../services/auth.service';
import { PermisosService } from '../services/permisos.service';
import { EmpresaService } from '../services/empresa.service';

import { Auth } from 'aws-amplify'

export interface IExpirationTime {
  timeLeft: number;
  idTimer: any;
}

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard implements CanActivate {

  private IDExpirationTimer: any;
  timeLeft$: Subject<IExpirationTime> = new Subject<IExpirationTime>();
  refreshToken$ = new BehaviorSubject<string>(null);

  constructor (
    private router: Router,
    public receptorService: ReceptorService,
    public usuarioService: UsuariosService,
    public authService: AuthService,
    public permisosService: PermisosService,
    public empresaService: EmpresaService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      // return true;
      return Auth.currentAuthenticatedUser().then(() => {
        return this.validacionTipoLogin()
        }).catch(() => { 
        this.router.navigate(['/login']);
        return false;
      });  
  }

  subdomainUser:any
  async validacionTipoLogin(){
    let value = true
    let tipoLogin = localStorage.getItem('ACCESS_LOGIN')
    let options = localStorage.getItem('OPCIONES')
    this.subdomainUser = localStorage.getItem('ACESS_SUB')
    console.log('access',options)
    console.log('tipoLogin',tipoLogin)
    if((tipoLogin == 'GOOGLE' || tipoLogin == 'SIGNINWITHAPPLE' || tipoLogin == 'FACEBOOK') && options == null){
      console.log('Entrando Redes Sociales')
      const attr = await Auth.currentUserInfo()
      this.obtenerUsuario(attr.attributes)
      value = false;
    }
    this.handleTokenExpiration()
    return value
  }

  emailUser:any
  /*async getAttributes(){
    await Auth.currentUserInfo().then( user => {
      console.log('usuario info',user)
      this.emailUser = user.attributes.email
      let attrib = JSON.parse(user.attributes.identities)
      localStorage.setItem('GIVENNAME', user.attributes.given_name)
      localStorage.setItem('FAMILYNAME', user.attributes.family_name)
      localStorage.setItem('USERCREATOR', attrib[0].providerName.toUpperCase())
      //this.obtenerUsuario(user.attributes.email,this.subdomainUser,user.attributes)
    }).catch( err => {
      alert(err.message || JSON.stringify(err))
    })
  }*/

  companysUser:any = "[{'id': 1, 'reasonSocial': 'INDIGITAL SOLUTIONS SAC', 'ruc': '0123456789'}]"
  async obtenerUsuario(attributes:any) {
    this.emailUser = attributes.email
    let attrib = JSON.parse(attributes.identities)
    let newuser: any = {
      name: attributes.given_name,
      paternalSurname: attributes.family_name,
      maternalSurname: '',
      identityNumber: '12345678',
      email: attributes.email,
      phoneNumber:'+51999999999',
      login:'12345678',
      identityType:'DEFAULT',
      nationalType:'PE',
      idProfile: "[2]",
      role: [1],
      office:"0",
      document_visado:[],
      document_type:[],
      idTipoFirma:"[1,2,4,5]",
      editSignigProcess: false,
      enableSignigProcess: false,
      userCreator: attrib[0].providerName.toUpperCase(),
      subdomain: this.subdomainUser,
      companys: this.companysUser,
      user:attributes.email
    }
    await this.receptorService.createUserProvider(newuser).then(data => {
      console.log('success XD',data)
      this.dologin()
    })
    .catch(error => {
      console.log('error',error)
    })
  }

 /* async obtenerUsuario(email:any, subdominio:any,attributes:any) {
    this.receptorService.obtenerUsuarioProvider(email,subdominio).subscribe( data => {
      if(data != null && !data.exist){
        console.log('no existe')
        this.createUser(attributes)
      }else{
        console.log('existe')
        this.dologin()
      }
    }, error => {
        console.log('##### Error al obtener usuario ', error)
    })
  }

  companysUser:any = "[{'id': 1, 'reasonSocial': 'INDIGITAL SOLUTIONS SAC', 'ruc': '0123456789'}]"
  async createUser( attributes : any) {
    let attrib = JSON.parse(attributes.identities)
    let newuser: any = {
      name: attributes.given_name,
      paternalSurname: attributes.family_name,
      maternalSurname: '',
      identityNumber: '12345678',
      email: attributes.email,
      phoneNumber:'+51999999999',
      login:'12345678',
      identityType:'DEFAULT',
      nationalType:'PE',
      idProfile: "[2]",
      role: [1],
      office:"0",
      document_visado:[],
      document_type:[],
      idTipoFirma:"[1]",
      editSignigProcess: false,
      enableSignigProcess: false,
      userCreator: attrib[0].providerName.toUpperCase(),
      subdomain: this.subdomainUser,
      companys: this.companysUser
    }
    console.log('### newuser ', newuser)

    this.receptorService.crearUsuarioProvider(newuser).subscribe( data => {
        //console.log('##### Creación Usuario exitosa')
        this.dologin()
    }, error => {
        console.log('##### Error al crear usuario ', error)
    })
  }*/

  async dologin() {
    console.log('##### Entrando DoLogin')
    
    localStorage.setItem('AUTHUSER', this.emailUser)
    localStorage.setItem('AUTHSUBDOMINIO', this.subdomainUser)
    localStorage.setItem('AUTHRECAPCHA', 'false')
    localStorage.setItem('AUTHSTART', 'start')
    let tipoLogin = localStorage.getItem('ACCESS_LOGIN')
    localStorage.setItem('ACCESS_LOGIN',tipoLogin)
    localStorage.setItem('OPCIONES','[]')
    this.router.navigate(['/'])
   /* setTimeout(() => {
      console.log("inicio de session")
      this.router.navigate(['/'])
    }, 5000)*/
    
   /* this.usuarioService.obtenerUsuario(this.emailUser, this.subdomainUser).subscribe(data => {
      console.log("VER",data)
      this.authService.guardarDatos(data)
      //this.permisosService.setOpciones()
      this.router.navigate(['/'])
      this.empresaService.obtenerEmpresaActiva(this.authService.obtenerIdEmpresaActiva()).subscribe(data => {

        this.authService.guardarDataEmpresaActiva(data.find(c => c.id == this.authService.obtenerIdEmpresaActiva()))
        this.router.navigate(['/'])
      }, error => {
        console.log(error)
        //this.errorLogout()
      })

    }, error => {
      console.log(error)
      //this.errorLogout()
    })*/
    
  }

  async handleTokenExpiration(): Promise<void> {
    const credentials = await Auth.currentUserCredentials();
    const expiration = credentials['expiration'];

    if (expiration) {
      const tokenExpirationDate = new Date(expiration);
      this.autoLogout(tokenExpirationDate.getTime() - new Date().getTime());
      localStorage.setItem('expiration', expiration.toString());
    }
  }

  private autoLogout(expirationDuration: number): void {
    const timeout = 30 * 1000;

    if (this.IDExpirationTimer) {
      clearTimeout(this.IDExpirationTimer);
    }
  
    this.IDExpirationTimer = setTimeout(() => {
      this.timeLeft$.next({
        timeLeft: timeout / 1000,
        idTimer: this.IDExpirationTimer
      });
    }, expirationDuration - timeout);
  }
  
}
